export const gaPhrase = (ga) => {
  if (!ga || (!ga.code && !ga.name)) return '-'
  const gaCode = !!ga.code ? ga.code : ''
  const gaName = !!ga.name ? ga.name : ''
  return `${gaCode} ${gaName}`.trim()
}
